import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';

function Sitemap() {
  const breadcrumbs = [
    { label: 'Sitemap', path: '/sitemap' },
  ];

  return (
    <div className="font-[Arial] text-black">
      <Header />
      <Breadcrumb items={breadcrumbs} />

      {/* Main Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold mb-12">Website Sitemap</h1>
            <p className="text-gray-600 mb-12">
              Welcome to the Moreflex Aviation sitemap. Here you'll find links to all important pages on our website.
              This page helps search engines understand our site structure and helps you navigate easily.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              {/* Main Pages */}
              <div>
                <h2 className="text-2xl font-bold mb-6 pb-3 border-b-2 border-[#73BDF2]">Main Pages</h2>
                <ul className="space-y-3">
                  <li>
                    <Link to="/" className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link to="/about" className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300">
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact" className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300">
                      Contact Us
                    </Link>
                  </li>
                  <li>
                    <Link to="/partners" className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300">
                      Partners & Affiliations
                    </Link>
                  </li>
                  <li>
                    <Link to="/resources" className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300">
                      Industry Resources & Links
                    </Link>
                  </li>
                  <li>
                    <Link to="/faq" className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300">
                      FAQ
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Services */}
              <div>
                <h2 className="text-2xl font-bold mb-6 pb-3 border-b-2 border-[#73BDF2]">Our Services</h2>
                <ul className="space-y-3">
                  <li>
                    <Link to="/services" className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300">
                      All Services Overview
                    </Link>
                  </li>
                  <li>
                    <Link to="/services#meet-greet" className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300">
                      Meet and Greet Service
                    </Link>
                  </li>
                  <li>
                    <Link to="/services#lounge" className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300">
                      Lounge Services
                    </Link>
                  </li>
                  <li>
                    <Link to="/services#chauffeur" className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300">
                      Fleet Services & Chauffeur
                    </Link>
                  </li>
                  <li>
                    <Link to="/services#baggage" className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300">
                      Baggage Assistance
                    </Link>
                  </li>
                  <li>
                    <Link to="/services#fast-track" className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300">
                      Fast-Track Security
                    </Link>
                  </li>
                  <li>
                    <Link to="/services#concierge" className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300">
                      Concierge Services
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Resources */}
              <div>
                <h2 className="text-2xl font-bold mb-6 pb-3 border-b-2 border-[#73BDF2]">Resources & Travel Links</h2>
                <ul className="space-y-3">
                  <li>
                    <a
                      href="https://www.iata.org/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300"
                    >
                      IATA - International Air Transport Association
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.icao.int/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300"
                    >
                      ICAO - International Civil Aviation Organization
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.iata.org/en/publications/directories/code-search/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300"
                    >
                      IATA Airport Codes Directory
                    </a>
                  </li>
                </ul>
              </div>

              {/* Information */}
              <div>
                <h2 className="text-2xl font-bold mb-6 pb-3 border-b-2 border-[#73BDF2]">Information & Policies</h2>
                <ul className="space-y-3">
                  <li>
                    <a href="#" className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300">
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300">
                      Terms & Conditions
                    </a>
                  </li>
                  <li>
                    <a href="/sitemap" className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300">
                      Sitemap (HTML)
                    </a>
                  </li>
                  <li>
                    <a href="/sitemap.xml" className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300">
                      Sitemap (XML)
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Additional Info */}
            <div className="mt-12 p-8 bg-gray-50 rounded-lg border-l-4 border-[#73BDF2]">
              <h3 className="text-lg font-bold mb-4">About This Sitemap</h3>
              <p className="text-gray-600 mb-4">
                This HTML sitemap provides an organized view of all pages available on the Moreflex Aviation website.
                It's designed to help visitors navigate our site and assist search engines in indexing our content.
              </p>
              <p className="text-gray-600">
                For an XML sitemap (used primarily by search engines), please visit our{' '}
                <a href="/sitemap.xml" className="text-[#73BDF2] hover:text-[#5ba8e0]">
                  XML Sitemap
                </a>
                .
              </p>
            </div>

            {/* CTA */}
            <div className="mt-12 text-center">
              <h3 className="text-xl font-bold mb-4">Need Help?</h3>
              <p className="text-gray-600 mb-6">
                Can't find what you're looking for? Contact our support team.
              </p>
              <Link
                to="/contact"
                className="inline-block bg-[#73BDF2] text-white px-8 py-3 rounded hover:bg-[#5ba8e0] transition-colors duration-300"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Sitemap;
